import { forwardRef } from "react"
import { Users, Landmark, Code2, AtSign } from "lucide-react"
import { SearchResult } from "../../../types"
import { getSearchResultDetails } from "./result-details"

interface Props {
  data: SearchResult
  isActive: boolean
  comfortable?: boolean
  onClickItem: (item: SearchResult) => void
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void
}

const getIcon = (type: string) => {
  switch (type) {
    case "integration":
      return <Code2 size={16} />
    case "subscription":
      return <AtSign size={16} />
    case "loan_officer":
      return <Users size={16} />
    case "brand":
      return <Landmark size={16} />
    default:
      return null
  }
}

const RecentSearchItem = forwardRef<HTMLDivElement, Props>(
  ({ data, isActive, comfortable = false, onClickItem, onKeyDown }, ref) => {
    const details = getSearchResultDetails(data)
    const rowPadding = comfortable ? "py-3" : "py-2"
    return (
      <div
        ref={ref}
        role="option"
        aria-selected={isActive}
        tabIndex={-1}
        key={data.id}
        className={`group search-result flex items-center gap-3 px-3 ${rowPadding} text-sm cursor-pointer rounded-md hover:bg-primary-400 hover:text-white transition-colors focus:outline-none ${
          isActive ? "bg-primary-400 text-white" : ""
        }`}
        onClick={() => onClickItem(data)}
        onKeyDown={onKeyDown}
      >
        <div
          className={`shrink-0 ${
            isActive ? "text-white" : "text-neutral-400 group-hover:text-white"
          }`}
        >
          {getIcon(data.type)}
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate">{data.item}</div>
          {details.length > 0 && (
            <div
              className={`text-xs truncate ${
                isActive
                  ? "text-white/80"
                  : "text-neutral-500 group-hover:text-white/80"
              }`}
            >
              {details.join(" · ")}
            </div>
          )}
        </div>
        <div
          className={`search-result-type shrink-0 text-xs capitalize ${
            isActive
              ? "text-white/80"
              : "text-neutral-400 group-hover:text-white/80"
          }`}
        >
          {data.type?.split("_").join(" ")}
        </div>
      </div>
    )
  }
)

RecentSearchItem.displayName = "RecentSearchItem"

export default RecentSearchItem
